import { render, staticRenderFns } from "./musicwowApp.vue?vue&type=template&id=a25047e4&scoped=true"
import script from "./musicwowApp.vue?vue&type=script&lang=js"
export * from "./musicwowApp.vue?vue&type=script&lang=js"
import style0 from "./musicwowApp.vue?vue&type=style&index=0&id=a25047e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25047e4",
  null
  
)

export default component.exports